import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles'; 
import { useConfig } from "../../services/ConfigContext";

const SuggestionDetailsDialog = ({
  open,
  onClose,
  data,
  onDownload,
}) => {
  const theme = useTheme(); 
  const isDark = theme.palette.mode === 'dark'; 

  const { config, loading } = useConfig();
  const isAttachment = config?.isAttachment;

  if (!data) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'background.paper', 
        }
      }}
    >
       <DialogTitle 
         sx={{ 
           fontSize: '18px', 
           fontWeight: 'Bold',
           bgcolor: 'background.paper',
           color: 'text.primary'
         }}
       >
         Suggestion / Issue Details
       </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: 'background.paper', borderColor: 'divider' }}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="body2" sx={{ color: 'text.primary' }}>
            <b>Type:</b> {data.feedbackCategory}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.primary' }}>
            <b>Status:</b> {data.status || '-'}
          </Typography>

          <Box>
            <Typography variant="body2" fontWeight={600} sx={{ color: 'text.primary' }}>Description</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
              {data.description || '-'}
            </Typography>
          </Box>
          
    {isAttachment && (
          <Box>
            <Typography variant="body2" fontWeight={600} sx={{ color: 'text.primary' }}>Attachments</Typography>

            {data.uploadedFiles?.length ? (
              data.uploadedFiles.map((file) => (
                <Typography variant="body2"
                  key={file.id}
                  sx={{
                    color: isDark ? '#90caf9' : 'primary.main',
                    cursor: 'pointer',
                    width: 'fit-content',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                  onClick={() =>
                    onDownload(file.id, file.fileName)
                  }
                >
                  {file.fileName}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No attachments
              </Typography>
            )}
          </Box>)}
        </Box>
      </DialogContent>

      <DialogActions sx={{ bgcolor: 'background.paper' }}>
        <Button onClick={onClose} sx={{ color: isDark ? '#90caf9' : 'primary.main' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuggestionDetailsDialog;